import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useUpdateTeam(teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: { name?: string; picture_url?: string; description?: string }) => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.patch(`/teams/${teamId}`, data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teams'] })
      queryClient.invalidateQueries({ queryKey: ['superadmin-teams'] })
    },
  })
}

export function useGrantAdmin(teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userId: string) => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.post(`/teams/${teamId}/grant-admin`, { user_id: userId })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team-users'] })
    },
  })
}

export function useRevokeAdmin(teamId?: string) {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userId: string) => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.post(`/teams/${teamId}/revoke-admin`, { user_id: userId })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['team-users'] })
    },
  })
}

